/* tslint:disable */
/* eslint-disable */
export enum ImportStatus {
  Requested = 'requested',
  Running = 'running',
  Failed = 'failed',
  Completed = 'completed'
}
